import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'agpr-newsroom',
    templateUrl: './newsroom.component.html',
    styleUrls: ['./newsroom.component.scss'],
    standalone: false
})
export class NewsroomComponent implements OnInit {
    constructor(public titleService: Title) { }

    ngOnInit(): void {
        this.titleService.setTitle('Newsroom - Agility');
    }
}
